import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarCNPJ, formatarCPF, formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import { Score } from "../../../components/Score";

 
 
 
export default function RestricaoPalladium({
  restricaoPalladium
}: {
    restricaoPalladium: any
}) {
  const { t } = useTranslation();

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };
 
  const getResumoRefin = () => {
    const resumos: any[] = [];
    if(restricaoPalladium.dados && restricaoPalladium.dados.refin && restricaoPalladium.dados.refin.registro && restricaoPalladium.dados.refin.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Registros',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-calendar-clock',
        label: 'Última ocorrência',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      let data:Date|null = null
      restricaoPalladium.dados.refin.registro.forEach((ocorrencia:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(ocorrencia.valor.replaceAll('.', '').replace(',', '.'))
        const [mes, ano, ] = ocorrencia.data_entrada.split(/[\/: ]/).map((v: string) => parseInt(v));
        const dataFormatada = new Date(ano, mes - 1);
        if(data == null || data < dataFormatada){
          data = dataFormatada
        }
        
      });
      resumos[1].value = (data ? formatDate(data) : '');
      resumos[0].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    return resumos;
  }
 
  const getResumo = () => {
    const resumos: any[] = [];
    if(restricaoPalladium.dados && restricaoPalladium.dados.pefin && restricaoPalladium.dados.pefin.registro && restricaoPalladium.dados.pefin.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Registros',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-calendar-clock',
        label: 'Última ocorrência',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      let data:Date|null = null
      restricaoPalladium.dados.pefin.registro.forEach((ocorrencia:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(ocorrencia.valor.replaceAll('.', '').replace(',', '.'))
        const [mes, ano, ] = ocorrencia.data_entrada.split(/[\/: ]/).map((v: string) => parseInt(v));
        const dataFormatada = new Date(ano, mes - 1);
        if(data == null || data < dataFormatada){
          data = dataFormatada
        }
        
      });
      resumos[1].value = (data ? formatDate(data) : '');
      resumos[0].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    return resumos;
  }

  const resumos = [];

  if(restricaoPalladium.dados.resumo){
    if(restricaoPalladium.dados.resumo.cheque_sem_fundo){
      resumos.push({resumo:'Cheque sem fundo', quantidade: restricaoPalladium.dados.resumo.cheque_sem_fundo.quantidade, data: restricaoPalladium.dados.resumo.cheque_sem_fundo.data_ultimo, total: '-'})
    }
    if(restricaoPalladium.dados.resumo.protesto){
      resumos.push({resumo:'Protesto', quantidade: restricaoPalladium.dados.resumo.protesto.quantidade, data: restricaoPalladium.dados.resumo.protesto.data_ultimo, total: restricaoPalladium.dados.resumo.protesto.valor_total})
    }
    if(restricaoPalladium.dados.resumo.refin){
      resumos.push({resumo:'Refin', quantidade: restricaoPalladium.dados.resumo.refin.quantidade, data: restricaoPalladium.dados.resumo.refin.data_ultimo, total: restricaoPalladium.dados.resumo.refin.valor_total})
    }
    if(restricaoPalladium.dados.resumo.pefin){
      resumos.push({resumo:'Pefin', quantidade: restricaoPalladium.dados.resumo.pefin.quantidade, data: restricaoPalladium.dados.resumo.pefin.data_ultimo, total: restricaoPalladium.dados.resumo.pefin.valor_total})
    }
    if(restricaoPalladium.dados.resumo.pendencias_vencidas){
      resumos.push({resumo:'Pendência', quantidade: restricaoPalladium.dados.resumo.pendencias_vencidas.quantidade, data: restricaoPalladium.dados.resumo.pendencias_vencidas.data_ultimo, total: restricaoPalladium.dados.resumo.pendencias_vencidas.valor_total})
    }

  }

  const getRange = (pontuacao:number) => {
        
    if(pontuacao >= 400 && pontuacao < 500){
        return 'REGULAR'
    }

    if(pontuacao >= 500 && pontuacao < 600){
        return 'BOM'
    }
    if(pontuacao >= 600){
        return 'OTIMO'
    }

    return 'RUIM'
  }
 
  const getResumoProtesto = () => {
      const resumos: any[] = [];
      if(restricaoPalladium.dados.protesto && restricaoPalladium.dados.protesto.registro.length > 0){
        resumos.push({
          icon: 'pi pi-chart-line',
          label: 'Quantidade Comarcas',
          value: 0
        })
        resumos.push({
          icon: 'pi pi-gauge',
          label: 'Quantidade Protestos',
          value: 0
        })
        resumos.push({
          icon: 'pi pi-dollar',
          label: 'Valor Total Protestos',
          value: '0'
        })
        let valorTotal = 0.0
        let quantidade = 0;
        const comarcas: any[] = []
        restricaoPalladium.dados.protesto.registro.forEach((prot:any) => {
          quantidade ++;
          valorTotal = valorTotal + Number(prot.valor.replace('.', '').replace(',', '.'))
          if(!comarcas.includes(prot.origem)){
            comarcas.push(prot.origem)
          }
        });
        resumos[0].value = comarcas.length;
        resumos[1].value = quantidade;
        resumos[2].value = formatarParaMoedaBRL(valorTotal);
      }
      
      return resumos;
    }
 
  const numberFormat = (value:number, width:number) => {
    return new Array(width + 1 - (value + '').length).join('0') + value;
  }

  const cnpjEmpresa = (item:any) => {
    return formatarCNPJ(item.cnpj);
  };

  const documentoSocio = (item:any) => {
    return item.cpf_cnpj.length == 11 ? formatarCPF(item.cpf_cnpj) : formatarCNPJ(item.cpf_cnpj);
  };


  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoPalladium.dados.protesto.registro && restricaoPalladium.dados.protesto.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span>) }</div>;
  }

  const headerTemplateCCF = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoPalladium.dados.cheque_sem_fundo.registro && restricaoPalladium.dados.cheque_sem_fundo.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('ccf')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('ccf')}</span>) }</div>;
  }

  const headerTemplatePendencia = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoPalladium.dados.pendencias_vencidas.registro && restricaoPalladium.dados.pendencias_vencidas.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendencia')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendencia')}</span>) }</div>;
  }

  const headerTemplateRefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoPalladium.dados.refin.registro && restricaoPalladium.dados.refin.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('refins')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('refins')}</span>) }</div>;
  }

  const headerTemplatePefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {restricaoPalladium.dados.pefin.registro && restricaoPalladium.dados.pefin.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span>) }</div>;
  }

 
  
  return (
    <div>
    {restricaoPalladium.mensagemErro ? (<p>{restricaoPalladium.mensagemErro}</p>) :
    (<div>
      {restricaoPalladium.dados.dados_cadastrais.cpf &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCPF(numberFormat(restricaoPalladium.dados.dados_cadastrais.cpf, 11))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('nome')}</label>
                      <Chip style={{width:"100%"}} label={restricaoPalladium.dados.dados_cadastrais.nome} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('nomeMae')}</label>
                      <Chip style={{width:"100%"}} label={restricaoPalladium.dados.dados_cadastrais.nome_mae} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('situacao')}</label>
                      <Chip style={{width:"100%"}} label={restricaoPalladium.dados.dados_cadastrais.situacao} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataNascimento')}</label>
                      <Chip style={{width:"100%"}} label={restricaoPalladium.dados.dados_cadastrais.data_nascimento} />
                  </div>
                </div>
                <div className="col">
              
                </div>
            </div>
          
          </Panel>
          <br></br>
        <Panel header={t('empresas')}>
            <DataTable size="small" value={restricaoPalladium.dados.participacao_empresas.registro} tableStyle={{ minWidth: '50rem' }}>
                <Column body={cnpjEmpresa} header={t('cnpj')}></Column>
                <Column field="razao_social" header={t('razaoSocial')}></Column>
                <Column field="cargo" header={t('cargo')}></Column>
                <Column field="data_entrada" header={t('data')}></Column>
            </DataTable>
        
        </Panel>
    
          
        

           
         
        </div>
      ) }
    {restricaoPalladium.dados.dados_cadastrais.cnpj &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCNPJ(numberFormat(restricaoPalladium.dados.dados_cadastrais.cnpj, 14))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('razaoSocial')}</label>
                      <Chip style={{width:"100%"}} label={restricaoPalladium.dados.dados_cadastrais.razao_social} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataFundacao')}</label>
                      <Chip style={{width:"100%"}} label={restricaoPalladium.dados.dados_cadastrais.data_fundacao} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('situacao')}</label>
                      <Chip style={{width:"100%"}} label={restricaoPalladium.dados.dados_cadastrais.situacao ? restricaoPalladium.dados.dados_cadastrais.situacao : 'Não Informado'} />
                    </div>
                </div>
            </div>
           
          
          </Panel>
          <br></br>
        <Panel header={t('quadroSocietario')}>
            <DataTable size="small" value={restricaoPalladium.dados.quadro_societario.registro} tableStyle={{ minWidth: '50rem' }}>
                <Column body={documentoSocio} header={t('documento')}></Column>
                <Column field="nome" header={t('nome')}></Column>
                <Column field="cargo" header={t('cargo')}></Column>
                <Column field="percentual_participacao" header={t('percentual')}></Column>
            </DataTable>
        
        </Panel>
    
          
        

           
         
        </div>
      ) }
    {restricaoPalladium.dados.alertas_restricoes && restricaoPalladium.dados.alertas_restricoes.registro && restricaoPalladium.dados.alertas_restricoes.registro.length > 0 && (
      <div>
        <br></br>
        <Panel header='Alerta'>
            <DataTable size="small" value={restricaoPalladium.dados.alertas_restricoes.registro} tableStyle={{ minWidth: '50rem' }}>
                <Column field="tipo_informacao" header={t('tipo')}></Column>
                <Column field="titulo" header={t('titulo')}></Column>
                <Column field="observacoes" header={t('descricao')}></Column>
            </DataTable>
        </Panel>
      </div>
    ) }

    {restricaoPalladium.dados.score  && (
      <div>
         <br></br>
         <Panel header="Score">
              <div style={{ display: "flex", gap: "40px" }}>
                <div
                  className="scrScore"
                >
                  <Score
                    score={restricaoPalladium.dados.score.pontuacao ? restricaoPalladium.dados.score.pontuacao : '0'}
                    range={getRange(restricaoPalladium.dados.score.pontuacao ? restricaoPalladium.dados.score.pontuacao : '0')}
                  />
               
                </div>
                <div style={{paddingTop:'2rem', paddingLeft: '2rem'}}>
                  <span style={{color:'#5a5c69', fontWeight:'700', fontSize:'1.25rem'}}>{t('probabilidadeInadimplencia')}</span>
                  <br></br>
                  <span style={{fontWeight:'700', fontSize:'1.5rem'}}>{restricaoPalladium.dados.score.probabilidade_inadimplencia}</span>
                </div>
              </div>
            </Panel>
      </div>
    )}

    {resumos.length > 0 && (
      <div>
         <br></br>
        <Panel header='Resumo'>
          <DataTable size="small" value={resumos} tableStyle={{ minWidth: '50rem' }}>
              <Column field="resumo" header={t('resumo')}></Column>
              <Column field="quantidade" header={t('quantidade')}></Column>
              <Column field="data" header={t('ultimaOcorrencia')}></Column>
              <Column field="total" header={t('total')}></Column>
          </DataTable>
        </Panel>
      </div>
    )}
      
    <br></br>
    <Panel headerTemplate={headerTemplateProtesto}>
        {restricaoPalladium.dados.protesto.registro.length === 0 ? ( <NadaConsta />) : (<>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumoProtesto().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={restricaoPalladium.dados.protesto.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_protesto" header={t('data')}></Column>
            <Column field="cartorio" header={t('cartorio')}></Column>
            <Column field="origem" header={t('cidade')}></Column>
            <Column field="estado" header={t('uf')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplateRefin}>
        {restricaoPalladium.dados.refin.registro.length === 0 ? ( <NadaConsta />) : (<>
         <div className="flex-consulta  flex-wrap gap-3">
          {getResumoRefin().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={restricaoPalladium.dados.refin.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_entrada" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column field="avalista" header={t('natureza')}></Column>
            <Column field="informante" header={t('informante')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplatePefin}>
        {restricaoPalladium.dados.pefin.registro.length === 0 ? ( <NadaConsta />) : (<>
         <div className="flex-consulta  flex-wrap gap-3">
          {getResumo().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={restricaoPalladium.dados.pefin.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_entrada" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column field="avalista" header={t('natureza')}></Column>
            <Column field="informante" header={t('informante')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplatePendencia}>
        {restricaoPalladium.dados.pendencias_vencidas.registro.length === 0 ? ( <NadaConsta />) : (<>
        <DataTable size="small" value={restricaoPalladium.dados.pendencias_vencidas.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_entrada" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column field="tipo_ocorrencia" header={t('tipo')}></Column>
            <Column field="avalista" header={t('avalista')}></Column>
            <Column field="informante" header={t('informante')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>
    <Panel headerTemplate={headerTemplateCCF}>
        {restricaoPalladium.dados.cheque_sem_fundo.registro.length === 0 ? ( <NadaConsta />) : (<>
        <DataTable size="small" value={restricaoPalladium.dados.cheque_sem_fundo.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_da_ocorrencia" header={t('dataUltimaOcorrencia')}></Column>
            <Column field="quantidade_cheques" header={t('quantidade')}></Column>
            <Column field="agencia" header={t('agencia')}></Column>
            <Column field="banco" header={t('banco')}></Column>
            <Column field="nome_banco" header={t('nomeBanco')}></Column>
        </DataTable>
        </>)}
    </Panel>

    </div>)}
  </div>
  )
}